import React from "react";
import { House, Building2, Zap, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Welder Calibration",
  description: "Precision calibration for Miller and Lincoln systems to ensure consistent arc performance and strict compliance with industry standards.",
  icon: House,
  link: "/RepairSolutionsPage"
}, {
  title: "Plasma Cutter Repair",
  description: "Specialized maintenance for Hypertherm plasma units, restoring optimal cutting speed and extending the life of your consumables.",
  icon: Building2,
  link: "/RepairSolutionsPage"
}, {
  title: "Board Diagnostics",
  description: "Advanced circuit board troubleshooting and logic component repair to resolve system errors and prevent expensive full-unit replacements.",
  icon: Zap,
  link: "/RequestServicePage"
}];
export default function OurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38717" id="specialized-repair-solutions" ref={ref} className={`py-20 bg-[#111418] transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#f2f2f2] uppercase mb-4">
            Specialized Repair Solutions
          </h2>
          <p className="text-lg text-[#b3b3b3] font-medium leading-relaxed">
            Precision maintenance and technical restoration for industrial welding and cutting systems. 
            We focus on minimizing downtime for Miller, Lincoln, and Hypertherm equipment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {expertiseData.map((item, i) => <Card key={i} data-index={i} className="group relative overflow-hidden border-[#323942] bg-[#21252b] transition-all duration-300 hover:border-[#ff9d1c] hover:shadow-lg hover:shadow-[#ff9d1c]/10 rounded-sm">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-sm bg-[#52667a]/10 text-[#52667a] transition-transform duration-500 group-hover:scale-105">
                  <item.icon className="h-8 w-8 group-hover:animate-pulse" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-bold text-[#f2f2f2] group-hover:text-[#ff9d1c] transition-colors duration-300 uppercase tracking-tight">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base leading-relaxed text-[#b3b3b3] font-medium">
                  {item.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-4">
                <Link to={item.link} className="inline-flex items-center text-sm font-bold uppercase tracking-widest text-[#ff9d1c] transition-all group-hover:translate-x-1">
                  View Technical Specs
                  <ChevronRight className="ml-1 h-4 w-4" />
                </Link>
              </CardFooter>
              
              {}
              <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#ff9d1c]/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            </Card>)}
        </div>
      </div>
    </section>;
}